<script>
import { Bar, mixins } from 'vue-chartjs';

export default {
  name: 'bar-chart',
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'optionData'],
  watch: {
    // きれいな実装かは微妙なところだけど、optionをリアクティブにするなら、
    // watchで監視するしかないっぽいのでこうする。
    optionData: {
      handler() {
        this.renderChart(this.chartData, this.optionData);
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.optionData);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/atoms/BarChart.vue